module.exports = __webpack_public_path__ + "65dd6f580e672769a701c1610f7bad2c.svg";